import { Link } from 'react-router-dom';

import ColumnFilterSort from '../../components/tableServerSide/ColumnFilterSort';

import { formatDateTimestamp } from '../../util/date';
import { escapeSpecialCharsInFilterInput } from '../util';

export const columnSortModifiersProductContractGroups = {
  name: null,
  createTimestamp: null,
  createdBy: null,
  defaultSort: { createTimestamp: 'desc' }
};

export const columnFilterModifiersProductContractGroups = {
  name: { expression: 'Like', value: escapeSpecialCharsInFilterInput },
  createTimestamp: { value: value => value && Date.parse(value) && new Date(value).toISOString() },
  createdBy: { expression: 'Like' }
};

export const getProductContractGroupsColumns = () => {
  return [
    {
      Header: tableInstance => <ColumnFilterSort header='Name' tableInstance={tableInstance} />,
      accessor: 'name',
      width: 300,
      // eslint-disable-next-line react/prop-types
      Cell: ({ row, value }) => (
        <Link
          to={`/productContractGroups/edit/${row.original.id}`} // eslint-disable-line react/prop-types
          style={{ color: '#3498db', textDecoration: 'underline' }}
        >
          {value}
        </Link>
      )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Created' tableInstance={tableInstance} />,
      accessor: 'createTimestamp',
      width: 120,
      Cell: ({ value }) => formatDateTimestamp(value)
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Created By' tableInstance={tableInstance} />,
      width: 200,
      accessor: 'createdBy'
    }
  ];
};
